<template>
  <main class="page-operative page-operative-kpi">
    <div class="container-fluid">
      <div class="d-flex align-items-center justify-content-between">
        <PageTitle class="mb-1">KPI</PageTitle>

        <BFormCheckbox v-model="showValues" class="no-select" :switch="true">
          Mostra valori
        </BFormCheckbox>
      </div>

      <OperativeTable class="report-texts-size" dense>
        <tbody>
        <OperativeTableSectionTitle :years="yearsTableHeadings">Analisi per indici</OperativeTableSectionTitle>

        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years>Indici di struttura finanziaria</OperativeTableBodyHeader>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ISF1" :showValues="showValues">Elasticità degli impieghi</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ISF2" :showValues="showValues">Liquidità del capitale investito</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ISF3" :showValues="showValues">Rigidità dei finanziamenti</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ISF4" :showValues="showValues">Indebitamento</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ISF5" :showValues="showValues">Solidità patrimoniale</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.SSF" strong>Scoring struttura finanziaria</OperativeTableBodyRowKpi>

        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years>Indici di ciclo finanziario</OperativeTableBodyHeader>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ICF1" :showValues="showValues">Rotazione del capitale investito</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.SCF" strong>Scoring ciclo finanziario</OperativeTableBodyRowKpi>

        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years>Indici dell'andamento economico</OperativeTableBodyHeader>
        <OperativeTableBodyRowKpi :values="yearsTableRows.IAE1" :showValues="showValues">ROS</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.IAE2" :showValues="showValues">ROI</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.IAE3" :showValues="showValues">ROE</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.IAE4" :showValues="showValues">Tasso di indebitamento</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.SAE" strong>Scoring andamento economico</OperativeTableBodyRowKpi>

        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years>Leverage</OperativeTableBodyHeader>
        <OperativeTableBodyRowKpi :values="yearsTableRows.L1" :showValues="showValues">Leverage</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.SL" strong>Scoring leverage</OperativeTableBodyRowKpi>

        <OperativeTableEmptyBodyRow :years="yearsTableHeadings" />

        <OperativeTableSectionTitle :years="yearsTableHeadings">Analisi di equilibrio della struttura aziendale</OperativeTableSectionTitle>
        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years></OperativeTableBodyHeader>
        <OperativeTableBodyRowKpi :values="yearsTableRows.AESA1" :showValues="showValues">Liquidità</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.AESA2" :showValues="showValues">Disponibilità</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.AESA3" :showValues="showValues">Garanzia</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.AESA4" :showValues="showValues">Margine di tesoreria</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.AESA5" :showValues="showValues">Capitale di circolante netto</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.AESA6" :showValues="showValues">Margine di struttura</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.SESA" strong>Scoring equilibrio della struttura aziendale</OperativeTableBodyRowKpi>

        <OperativeTableEmptyBodyRow :years="yearsTableHeadings" />

        <OperativeTableSectionTitle :years="yearsTableHeadings">Z-Score - Probabilità di fallimento entro 2 anni</OperativeTableSectionTitle>
        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years></OperativeTableBodyHeader>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ZS1" :showValues="showValues">Indice di flessibilità aziendale</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ZS2" :showValues="showValues">Indice di autofinanziamento</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ZS3" :showValues="showValues">ROI</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ZS4" :showValues="showValues">Indice di indipendenza da terzi</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi :values="yearsTableRows.ZS5" :showValues="showValues">Turnover attività</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpiZScore :values="yearsTableRows.ZS" :showValues="showValues" strong>Z-Score</OperativeTableBodyRowKpiZScore>

        <OperativeTableEmptyBodyRow :years="yearsTableHeadings" />
        <OperativeTableSectionTitle :years="yearsTableHeadings">Rating</OperativeTableSectionTitle>
        <OperativeTableBodyHeader :years="yearsTableHeadings" show-years></OperativeTableBodyHeader>
        <OperativeTableBodyRow align="left" :values="yearsTableRows.R1">
          Grado di copertura delle immobilizzazioni nette
          <template #cell-content="{ value }">{{ value.score }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow align="left" :values="yearsTableRows.R2">
          Grado di indipendenza finanziaria
          <template #cell-content="{ value }">{{ value.score }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow align="left" :values="yearsTableRows.R3">
          Indice oneri finanziari su fatturato
          <template #cell-content="{ value }">{{ value.score }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow align="left" :values="yearsTableRows.R4">
          Liquidità generata dalla gestione
          <template #cell-content="{ value }">{{ value.score }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRowKpiRating :values="yearsTableRows.R" strong>Rating</OperativeTableBodyRowKpiRating>
        </tbody>
      </OperativeTable>
    </div>
  </main>
</template>

<script>

import { BFormCheckbox } from 'bootstrap-vue';
import operativePageMixin from '../../../../mixins/operativePage';
import loadingDataMixin from '../../../../mixins/loadingData';
import computedFinancialDataMixin from '../../../../mixins/computedFinancialData';
import OperativeTableBodyRowKpi from '../../../components/Operative/Kpi/OperativeTableBodyRowKpi';

export default {
  name: 'page-operative-company-kpi',
  mixins: [operativePageMixin, loadingDataMixin, computedFinancialDataMixin],
  components: {
    BFormCheckbox,
    PageTitle: () => import('../../../components/Layout/LayoutOperative/PageTitle'),
    OperativeTableSectionTitle: () => import('../../../components/Operative/OperativeTableSectionTitle'),
    OperativeTable: () => import('../../../components/Operative/OperativeTable'),
    OperativeTableBodyHeader: () => import('../../../components/Operative/OperativeTableBodyHeader'),
    OperativeTableBodyRow: () => import('../../../components/Operative/OperativeTableBodyRow'),
    OperativeTableBodyRowKpi,
    OperativeTableBodyRowKpiZScore: () => import('../../../components/Operative/Kpi/OperativeTableBodyRowKpiZScore'),
    OperativeTableBodyRowKpiRating: () => import('../../../components/Operative/Kpi/OperativeTableBodyRowKpiRating'),
    OperativeTableEmptyBodyRow: () => import('../../../components/Operative/OperativeTableEmptyBodyRow'),
  },
  data () {
    return {
      kpi: null,
      showValues: false,
    };
  },
  computed: {
    yearsTableHeadings () {
      return this.convertToYearsHeading(this.kpi);
    },
    yearsTableRows () {
      return this.convertToRowGroupAutomatically(this.kpi);
    },
  },
  methods: {
    retrieveData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();
      this.$api.getKpi(this.company?.id)
        .then(res => {
          this.kpi = res?.data?.kpi || [];
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
  },
  watch: {
    company () {
      this.retrieveData();
    },
  },
};

</script>

<style lang="scss">

.page-operative-kpi {
  .operative-table-body-header {
    .operative-table-value-column-header {
      text-align: left;
    }
  }
}

</style>
